import { Config, Store } from '../types';

import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';
import queryString from 'query-string';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import plugins from './plugins';
import state from './state';

Vue.use(Vuex);

export default function(config: Config): Store {
  // FUTURE: add more validation to params - only allowed keys and no features update
  const query = queryString.parse(location.search || config.search);
  const params = query.params ? JSON.parse(atob(query.params)) : {};

  const store = _.defaultsDeep({
    state: params,
    plugins,
  },
  config.store,
  {
    state,
    getters,
    mutations,
    actions,
  }) as Store;

  // Overwrite pay frequencies
  if (_.has(config.store, 'state.constants.PAY_FREQUENCIES')) {
    store.state.constants.PAY_FREQUENCIES = _.get(config.store, 'state.constants.PAY_FREQUENCIES');
  }

  // The first rate should always be visible
  store.state.ui.visibleRates.push(store.state.inputs.contributionRate || store.state.assumptions.contributionRates[0]);

  return new Vuex.Store(store);
}
